import {
  Component,
  ElementRef,
  inject,
  Input,
  output,
  viewChildren,
  input,
  ChangeDetectionStrategy,
} from '@angular/core';

import type {
  LanguageSwitcherItem,
  SegmentedButtonType,
} from './segmented-control-button/segmented-control-button.component';
import { SegmentedControlButtonComponent } from './segmented-control-button/segmented-control-button.component';

@Component({
  selector: 'rt-segmented-control',
  templateUrl: './segmented-control.component.html',
  styleUrls: ['./segmented-control.component.less'],
  host: {
    '[class.full-width]': 'fullwidth()',
    '[class.no-wrap]': 'noWrap()',
  },
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SegmentedControlButtonComponent],
})
export class SegmentedControlComponent<T> {
  public readonly elRef = inject(ElementRef);

  public readonly fullwidth = input<boolean>(undefined!);
  public readonly activeLanguage = input<string>(undefined!);
  public readonly loadingLanguageCode = input<string | null>(null);
  public readonly fieldsCount = input<number>(undefined!);
  public readonly isDisabled = input<boolean>();
  public readonly isAvailable = input<boolean>(undefined!);
  public readonly noWrap = input<boolean>(undefined!);
  public readonly defaultTranslationKey = input<string>(undefined!);
  public readonly primaryTranslationKey = input<string>(undefined!);
  public readonly progressTooltipTranslationKey = input<string>(undefined!);
  public readonly showIndicatorOnDefault = input<boolean>(undefined!);
  @Input() public type: 'view-switcher' | 'multilang-switcher';
  @Input() public segmentedButtons: Array<SegmentedButtonType<any>>;
  @Input() public languages: LanguageSwitcherItem[] = [];

  public segmentedControlButtons = viewChildren(SegmentedControlButtonComponent);
  public segmentedButtonClicked = output<T | LanguageSwitcherItem>();

  public trackByFn(index: number, item: SegmentedButtonType<T>): T | number {
    return item.value || index;
  }

  public trackByLangCode(index: number, item: LanguageSwitcherItem): string | number {
    return item.code || index;
  }
}
